// Configurable round-timer settings, persisted in localStorage.
// 0 means "no time limit".

const KEY = "cs.time.limit";
export const TIME_OPTIONS = [
  { seconds: 60, label: "1 min" },
  { seconds: 120, label: "2 min" },
  { seconds: 180, label: "3 min" },
  { seconds: 0, label: "No limit" },
];

export const DEFAULT_LIMIT = 60;

export const getTimeLimit = () => {
  try {
    const v = localStorage.getItem(KEY);
    if (v === null) return DEFAULT_LIMIT;
    const n = parseInt(v, 10);
    return Number.isFinite(n) && n >= 0 ? n : DEFAULT_LIMIT;
  } catch (err) {
    if (process.env.NODE_ENV !== "production") console.debug("timerSettings: localStorage read failed", err);
    return DEFAULT_LIMIT;
  }
};

export const setTimeLimit = (seconds) => {
  try {
    localStorage.setItem(KEY, String(seconds));
  } catch (err) {
    if (process.env.NODE_ENV !== "production") console.debug("timerSettings: localStorage write failed", err);
  }
  window.dispatchEvent(new CustomEvent("cs:time-limit", { detail: { seconds } }));
};
